import React, { FC } from 'react'
import { FiMinus, FiTrash } from "react-icons/fi";
import './ShoppingCartItem.scss'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { BUY_ACTION, IShoppingCarItem } from 'app_types/shoppingCart/shoppingCarTypes'
import { useDispatch, useSelector } from 'react-redux';
import { CombinedReducers } from 'app_events/index';
import { shoppingCarChange } from 'app_events/app/actions';
import { IActionsCart } from 'app_events/app/types';
import { MdAdd } from 'react-icons/md';

interface IShoppingCartItemProps {
  itemToBuy: IShoppingCarItem
}

const ShoppingCartItem: FC<IShoppingCartItemProps> = ({itemToBuy, ...props}) => {

  const dispatch = useDispatch()
  const {data: shoppingCarItems}: {action: IActionsCart, data: IShoppingCarItem[]} = useSelector((store: CombinedReducers) => store?.app?.shoppingCart ?? {action: 'none', data: []});

  const getPrice = () => {
    if (itemToBuy?.priceWithDiscount) {
      return itemToBuy.priceWithDiscount
    }
    return itemToBuy.price
  }

  const removeItemToBuy = () => {
    const _shoppingCarItems = shoppingCarItems.filter((i) => i && i?.identifier !== itemToBuy.identifier)
    dispatch(shoppingCarChange({action: 'remove', data: _shoppingCarItems}))
  }

  const addNumberOfPlace = () => {
    const _shoppingCarItems = shoppingCarItems.map((i) => {
      if (i && i?.identifier === itemToBuy.identifier) {
        i.numberOfPlaces++;
        if (i.numberOfPlaces > 1) {
          i.buyAction = BUY_ACTION.FOR_ME_AND_OTHERS;
        }
      }
      return i;
    })
    dispatch(shoppingCarChange({action: 'add', data: _shoppingCarItems}))
  }

  const removeNumberOfPlace = () => {
    if (itemToBuy.numberOfPlaces > 1) {
      const _shoppingCarItems = shoppingCarItems.map((i) => {
        if (i && i?.identifier === itemToBuy.identifier) {
          i.numberOfPlaces--;
          if (i.numberOfPlaces === 1) {
            i.buyAction = BUY_ACTION.FOR_MYSELF;
          }
        }
        return i;
      });
      dispatch(shoppingCarChange({action: 'remove', data: _shoppingCarItems}));
    } else {
      removeItemToBuy();
    }
  }

  return (
    <>
      {itemToBuy && (
        <div className='shopping_cart_item'>
          <div className="shopping_cart_item-layout">
            <div className='shopping_cart_item-image-wrapper'>
              <img src={itemToBuy.image} alt="" />
            </div>
            <div className='shopping_cart_item-content-wrapper'>
              <ul className='shopping_cart_item-content-list'>
                <li className='shopping_cart_item-title'>{itemToBuy.description}</li>
                <div className='shopping_cart_item-right-block'>
                  <span className='shopping_cart_item-price'>{getPrice()}</span>
                  <div className='shopping_cart_item-action-controls'>
                    <ButtonComponent
                      onClick={removeNumberOfPlace}
                      disabled={itemToBuy.numberOfPlaces === 1}
                    >
                      <FiMinus />
                    </ButtonComponent>
                    <div className='shopping_cart_item-quantity'>{itemToBuy.numberOfPlaces}</div>
                    <ButtonComponent
                      onClick={addNumberOfPlace}
                    >
                      <MdAdd />
                    </ButtonComponent>
                  </div>
                </div>
                <div className='shopping_cart_item-content-tail'>
                  <li><span>Fecha de inicio: {itemToBuy.startDate}</span></li>
                  <li><span>Modalidad: {itemToBuy.modality}</span></li>
                </div>
              </ul>
              <div className='shopping_cart_item-action-links'>
                <span>
                  <ButtonComponent
                    width='100%'
                    variant='clean'
                    className='shopping_cart_item-remove-button'
                    onClick={removeItemToBuy}
                  >
                    <FiTrash /> Remover
                  </ButtonComponent>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ShoppingCartItem
